const SWATCHES = "color-picker-color-swatches";
const SWATCH = "color-picker-color-swatch";
const SWATCH_TOOLTIP = "color-picker-colors-swatch-tooltip";
const ADD_CUSTOM_COLOR_BUTTON = "color-picker-add-custom-color-button";
const RESET_COLOR_BUTTON = "color-picker-reset-button";
export {
  ADD_CUSTOM_COLOR_BUTTON,
  RESET_COLOR_BUTTON,
  SWATCH,
  SWATCHES,
  SWATCH_TOOLTIP
};
//# sourceMappingURL=data-hooks.js.map
